export default __webpack_public_path__ + "static/media/GEMS-Logo.58080532.png";